'use strict';

// ital für Darsteller, Dauer, Regie

const renderMovies = (data, page = 1, actorList = 'Darsteller', length = 'Dauer', director = 'Regie') => {

    const timerStart = Date.now();
    const fragment = document.createDocumentFragment();

    page--;
    const maxItems = 25;

    let start = maxItems * page;
    let end = start + maxItems;

    let paginatedItems = data.slice(start, end);

    paginatedItems.map((ele, i) => {
        const listItem = document.createElement('li');
        listItem.className = "list-item";

        // create and append image-element

        const imgWrapper = document.createElement('div');
        imgWrapper.className = "image-wrapper";
        listItem.appendChild(imgWrapper);

        if(ele.image) {
            const image = document.createElement('img');
            image.setAttribute('src', `${ele.image}`);
            image.setAttribute('alt', `${ele.title}`);
            image.setAttribute('onerror', `this.onerror=null;this.src='';`);
            image.className = "item-image";
            imgWrapper.appendChild(image);
        } 

        // infoContainer

        const infoContainer = document.createElement('div');
        infoContainer.className = "info-container";
        listItem.appendChild(infoContainer);

        // header

        const header = document.createElement('header');
        header.className = 'item-header';
        infoContainer.appendChild(header);

        // screeningDate

        const screeningDate = document.createElement('span');
        screeningDate.textContent = `${ele.screeningDate}, ${ele.screeningTime} Uhr`;
        header.appendChild(screeningDate);

        // name

        const itemTitle = document.createElement('h2');
        itemTitle.textContent = ele.title.toUpperCase();
        itemTitle.style.marginBottom = "0px";
        header.appendChild(itemTitle);

        // country and year

        const countryAndYear = document.createElement('span');
        countryAndYear.textContent = `${ele.country} ${ele.releaseYear}, `;
        header.appendChild(countryAndYear);


        const runtime = document.createElement('span');
        runtime.textContent = `${length}: ${ele.runtime} min, `;
        header.appendChild(runtime);

        // director and version

        const directorAndVersion = document.createElement('strong');
        directorAndVersion.textContent = `${director}: ${ele.director} - ${ele.version}`;
        header.appendChild(directorAndVersion);

        // actorsContainer
        const actorsContainer = document.createElement('div');
        actorsContainer.className = 'actors-container';
        infoContainer.appendChild(actorsContainer);
        // actors

        const actors = document.createElement('span');
        const strong = document.createElement('strong');
        strong.textContent = `${actorList}: `
        actors.textContent = ele.actors;
        actorsContainer.appendChild(strong);
        actorsContainer.appendChild(actors);

        // Strong Copy Text

        if (ele.subtitle) {
            ele.subtitle.map(p => {
                const subtitle = document.createElement('p');
                subtitle.className = "strong-paragraph";
                subtitle.textContent = p;
                infoContainer.appendChild(subtitle);
            })
        }

        // Copy Text

        if (ele.bodycopy) {
            ele.bodycopy.map(p => {
                const bodyCopy = document.createElement('p');
                bodyCopy.className = "paragraph";
                bodyCopy.textContent = p;
                infoContainer.appendChild(bodyCopy);
            })
        }

        fragment.appendChild(listItem);
    })

    const duration = Date.now() - timerStart;
    // console.log(`duration: ${duration}`);

    return fragment;
}

export { renderMovies };